
define(
    'Tavano.TavanoteamGA4.TTGA4.Shopping'
    , [
        'Tavano.TavanoteamGA4.TTGA4.Utils'
        , 'AjaxRequestsKiller'
        , 'Backbone'
        , 'jQuery'
        , 'underscore'
    ]
    , function (
        TTGA4Utils
        , AjaxRequestsKiller
        , Backbone
        , jQuery
        , _
    ) {
        'use strict';
        var ga4Shopping = {
            cartCache: []
            , loadGA4Shopping: function loadGA4Shopping(container) {
                var self = this;
                this.trackPageGA4(container);
                this.trackProductSelectEventHandler(container);
                this.app = TTGA4Utils.getApplication('Shopping');
                sessionStorage.createWishlist = "false";
                var layout = container.getComponent('Layout');
                var cart = container.getComponent("Cart");
                container.getLayout().on('afterAppendView', function () {
                    $('.header-mini-cart-button-checkout[data-touchpoint="checkout"]').attr('data-action', 'proceedToCheckout');
                    $('.cart-summary-button-proceed-checkout[data-touchpoint="checkout"]').attr('data-action', 'proceedToCheckout');
                    var curView = container.getLayout().getCurrentView()
                        , miniCart = container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart')
                        //, recentlyViewedStr = TTGA4Utils.getCookieByName('recentlyViewedIds')
                        //, recentlyViewedArr = JSON.parse(decodeURIComponent(recentlyViewedStr))
                        , recentlyViewedArr = TTGA4Utils.getCookieByName('recentlyViewedIds')
                        , timeout = null;
                    var itemsSearcher = {};
                    if (container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch')) {
                        itemsSearcher = container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') || {};
                    }
                    //to ensure that previous events listeners are removed
                    //this is to avoid multiple triggers of the same event
                    //Start
                    if (Object.keys(itemsSearcher).length > 0 && itemsSearcher.$searchElement) {
                        itemsSearcher.$searchElement.off('keyup')
                        itemsSearcher.$searchElement.on('keyup', function (event) {
                            var searchQuery = jQuery(event.currentTarget).val();
                            clearTimeout(timeout);
                            timeout = setTimeout(function () {
                                if (searchQuery.trim().length >= itemsSearcher.options.minLength) {
                                    //Greenmill approach to prevent multiple calls to the Algoria server
                                    // if (searchQuery.trim().length > 0) {
                                    //     TTGA4Utils.trackSearchGA4(searchQuery.trim(), 'Search Suggestion', ga4Shopping.app);
                                    // }
                                    //END Greenmill approach
                                    var resultCollection = itemsSearcher.collection
                                        , sort = itemsSearcher.options.sort
                                        , limit = itemsSearcher.options.limit
                                        , ajaxKiller = AjaxRequestsKiller.AjaxRequestsKiller ? AjaxRequestsKiller.AjaxRequestsKiller : AjaxRequestsKiller;
                                    resultCollection.fetch({
                                        data: {
                                            q: String(searchQuery).trim()
                                            , sort: sort
                                            , limit: limit
                                            , offset: 0
                                        }
                                        , killerId: ajaxKiller.getKillerId()
                                    },
                                        {
                                            silent: true
                                        })
                                        .done(function (searchResult) {
                                            if (searchResult.items && searchResult.items.length > 0) {
                                                //console.log("here")
                                                TTGA4Utils.trackSearchGA4(searchQuery.trim(), 'Search Suggestion', ga4Shopping.app);
                                            }
                                        })
                                }
                            }, 500)
                        });
                    }
                    //end
                    if (curView.getChildViewInstance('Related.Items') && curView.getChildViewInstance('Related.Items').collection) {
                        if (curView.getChildViewInstance('Related.Items').collection.length > 0) {
                            self.trackProductListsEventHandler(container, 'related');
                        }
                    }
                    if (curView.getChildViewInstance('Correlated.Items') && curView.getChildViewInstance('Correlated.Items').collection) {
                        if (curView.getChildViewInstance('Correlated.Items').collection.models.length > 0) {
                            self.trackProductListsEventHandler(container, 'correlated');
                        }
                    }
                    if (curView.getChildViewInstance('RecentlyViewed.Items') && (recentlyViewedArr && recentlyViewedArr.length > 0)) {
                        self.trackProductListsEventHandler(container, 'recentlyviewed');
                    }
                    if (jQuery(curView.el)[0].id == 'facet-browse') {
                        self.trackProductListsEventHandler(container, 'plp');
                        //ADD THIS TO USE IN CATEGORY PAGE - CUSTOM
                        self.trackAddToCartEventHandler(container, 'categoryPage');
                    }
                    if (miniCart) {
                        cart.getLines().then(function (lines) {
                            if (lines.length > 0) {
                                cart.getPromotions().then(function (promotions) {
                                    cart.getSummary().then(function (summary) {
                                        self.trackCheckout(container, 'minicart', lines, promotions, summary);
                                    });
                                });
                            }
                        });
                    }
                    if (jQuery(curView.el)[0].id == 'ProductDetails.Full.View') {
                        self.trackAddToCartEventHandler(container);
                        self.trackProductViewGA4(container);
                        //self.trackAddToWishlistEventHandler(container);
                    }
                    if (jQuery(curView.el)[0].id == 'ProductDetails.QuickView.View') {
                        self.trackAddToCartEventHandler(container);
                        self.trackProductViewGA4(container);
                        //self.trackAddToWishlistEventHandler(container);
                    }
                    if (jQuery(curView.el)[0].id == "Cart.Detailed.View") {
                        self.trackRemoveItemInCartEventHandler(container);
                        self.trackViewCart(container);
                        self.trackCheckout(container, 'cart', null, null, null);
                        self.trackUpdateQtyEventHandler(container);
                    }
                    if (container.getLayout().getCurrentView().translator) {
                        self.trackSearch(container);
                    }
                });
            }
            , trackProductSelectEventHandler: function (container) {
                var layout = container.getLayout();
                layout.mouseDown.install({
                    name: 'tavanoTeamGA4ProductClickEvent',
                    priority: 20,
                    execute: function (e) {
                        var item = jQuery(e.currentTarget).closest('[itemprop="itemListElement"]');
                        if (item.length > 0) {
                            var category = item.data('track-productlist-category');
                            if (category) {
                                var price = "";
                                if (item.find('[itemprop="price"]').data('rate')) {
                                    price = item.find('[itemprop="price"]').data('rate');
                                } else if (item.find('.product-views-price-lead').data('rate')) {
                                    price = item.find('.product-views-price-lead').data('rate');
                                } else if (item.find('[itemprop="price"]')[0]) {
                                    price = item.find('[itemprop="price"]')[0].content;
                                } else if (item.find('[itemprop="lowPrice"]').data('rate')) {
                                    price = item.find('[itemprop="lowPrice"]').data('rate');
                                }
                                var currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                                var eventObj = {
                                    item_list_id: item.data('track-productlist-category')
                                    , item_list_name: item.data('track-productlist-list')
                                    , item: [{
                                        item_id: item.data('sku') + ""
                                        , item_name: item.find('[itemprop="name"]').text()
                                        , price: price
                                        , item_category: item.data('track-productlist-category')
                                        , currency: currencyCode
                                    }]
                                };
                                TTGA4Utils.trackProductSelectGA4(eventObj, container);
                            }
                        }
                        return e;
                    }
                })
            }
            , trackPageGA4: function (container) {
                container.getLayout().on('beforeAppendView', function () {
                    var curUrl = Backbone.history.fragment ? '/' + Backbone.history.fragment : '/';
                    var isInModal = container.getLayout().getCurrentView().inModal;
                    if (!isInModal) {
                        TTGA4Utils.trackPageViewGA4(curUrl, container, undefined, {
                            requireEngagement: true
                            , minEngagementMs: 3000
                            , minEngagementMsStrong: 500
                            , minEngagementMsRapidNavigate: 120
                        });
                    }
                });
            }
            , trackProductViewGA4: function (container) {
                var itemModel = container.getLayout().getCurrentView().model.get('item');
                var currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                var onlinePrice = "";
                if (itemModel.get('onlinecustomerprice_detail')) {
                    onlinePrice = itemModel.get('onlinecustomerprice_detail')['onlinecustomerprice'];
                }
                var itemData = {
                    currency: currencyCode
                    , value: onlinePrice
                    , item: [{
                        item_id: itemModel.get('itemid')
                        , item_name: itemModel.get('storedisplayname2')
                        , price: onlinePrice
                        , currency: currencyCode
                    }]
                };
                TTGA4Utils.trackProductViewGA4(itemData, container);
            }
            , trackAddToCartEventHandler: function (container, page) {
                var cartModel;
                var self = this;
                //ADD THIS TO USE IN CATEGORY PAGE - CUSTOM
                if (page == 'categoryPage') {
                    cartModel = container.getLayout().getCurrentView().cart;
                } else {
                    var mainActionView = container.getLayout().getCurrentView().getChildViewInstance('MainActionView') || container.getLayout().getCurrentView().mainActionViewInstance;
                    cartModel = mainActionView.cart;
                }
                ga4Shopping.pdpCart = cartModel;
                //remove previous event listener to avoid multiple triggers of the same event
                //START
                cartModel.cancelableOff('after:LiveOrder.addLines', this.trackAddToCartGA4, this);
                //END
                //Start of add to cart track event
                cartModel.cancelableOn('after:LiveOrder.addLines', this.trackAddToCartGA4, this);
                //END
            }
            , trackAddToCartGA4: function (oldline, updatedline, isAddQty) {
                var cartModel = {}
                    , itemObj = {}
                    , itemData = {}
                    , variantArr = []
                    , itemOptions = []
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                if (ga4Shopping.app.getLayout().getCurrentView().cart && !isAddQty) {
                    //model for when user is in PLP
                    //added item in quick view
                    cartModel = ga4Shopping.app.getLayout().getCurrentView().cart;
                    var latestItemId = cartModel.get('latest_addition')
                        , cartLines = cartModel.get('lines')
                        , latestItemModel = cartLines.get(latestItemId);
                    itemOptions = latestItemModel.get('options');
                    var itemName = "";
                    //Use parent item name for matrix items
                    if (latestItemModel.get('item').get('matrix_parent')) {
                        itemName = latestItemModel.get('item').get('matrix_parent')['storedisplayname2'];
                    } else {
                        itemName = latestItemModel.get('item').get('storedisplayname2') || latestItemModel.get('item').get('displayname') || latestItemModel.get('item').get('_name');
                    }
                    itemObj['item_id'] = latestItemModel.get('item').get('itemid') + "" || latestItemModel.get('item').get('itemid') + "";
                    itemObj['item_name'] = itemName;
                    itemObj['quantity'] = latestItemModel.get('quantity');
                    itemObj['currency'] = currencyCode;
                    itemObj['price'] = latestItemModel.get('rate');
                    itemData['currency'] = currencyCode;
                    itemData['value'] = latestItemModel.get('total') || latestItemModel.get('amount');
                    itemData['item'] = [];
                }
                else if (ga4Shopping.app.getLayout().getCurrentView().model && !isAddQty) {
                    //model for when user is in PDP
                    //item an item in PDP
                    cartModel = ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance ? ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance.cart : ga4Shopping.pdpCart;
                    var latestAddition = ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance ? cartModel.getLatestAddition() : cartModel.getLatestAddition()
                        , price = latestAddition.get('rate') ? latestAddition.get('rate') : latestAddition.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                        , totalValue = latestAddition.get('total') ? latestAddition.get('total') || latestAddition.get('amount') : latestAddition.get('quantity') * price;
                    itemOptions = latestAddition.get('options');
                    var itemName = "";
                    //Use parent item name for matrix items
                    if (latestAddition.get('item').get('matrix_parent')) {
                        itemName = latestAddition.get('item').get('matrix_parent')['storedisplayname2'];
                    } else {
                        itemName = latestAddition.get('item').get('storedisplayname2') || latestAddition.get('item').get('displayname') || latestAddition.get('item').get('_name');
                    }
                    itemObj['item_id'] = latestAddition.get('item').get('itemid') + "" || latestAddition.get('item').get('internalid') + "";
                    itemObj['item_name'] = itemName
                    itemObj['quantity'] = latestAddition.get('quantity');
                    itemObj['currency'] = currencyCode;
                    itemObj['price'] = price;
                    itemData['currency'] = currencyCode;
                    itemData['value'] = totalValue;
                    itemData['item'] = [];
                }
                else if (ga4Shopping.app.getLayout().getCurrentView().model && isAddQty) {
                    //model if user added a new qty from cart
                    cartModel = ga4Shopping.app.getLayout().getCurrentView().model;
                    var updatedLine = cartModel.getLatestAddition();
                    itemOptions = updatedLine.get('options');
                    if (updatedLine.get('item')) {
                        itemObj['item_id'] = updatedLine.get('item').get('itemid') + "" || updatedLine.get('item').get('internalid') + "";
                        itemObj['item_name'] = updatedLine.get('item').get('storedisplayname2') || updatedLine.get('item').get('displayname');
                        itemObj['quantity'] = updatedLine.get('quantity');
                        itemObj['currency'] = currencyCode;
                        itemObj['price'] = updatedLine.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                        itemData['currency'] = currencyCode;
                        itemData['value'] = updatedLine.get('total') || updatedLine.get('amount');
                        itemData['item'] = [];
                    }
                }
                //checks if user selected a specific item option when they added the item to the cart
                _.each(itemOptions.models, function (option) {
                    if (option.get('value')) {
                        variantArr.push(option.get('value').label);
                    }
                });
                if (variantArr.length > 0) {
                    itemObj['item_variant'] = variantArr.join(',');
                }
                if (Object.keys(itemData).length > 0) {
                    itemData.item.push(itemObj);
                    TTGA4Utils.trackAddToCartGA4(itemData, ga4Shopping.app)
                }
            }
            , trackUpdateQtyEventHandler: function (container) {
                var cartDetailedView = container.getLayout().getCurrentView()
                    , cartDetailedModel = cartDetailedView.model;
                cartDetailedModel.cancelableOff('after:LiveOrder.updateLine', this.trackUpdateQty, this);
                cartDetailedModel.cancelableOn('after:LiveOrder.updateLine', this.trackUpdateQty, this);
            }
            , trackUpdateQty: function (oldLine) {
                var cartDetailedView = ga4Shopping.app.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView ? cartDetailedView.model : {}
                    , cartDetailLines = cartDetailModel ? cartDetailModel.get('lines') : {}
                    , cartLinesModel = cartDetailLines ? cartDetailLines.models : {}
                    , oldLineId = oldLine.internalid
                    , cartCache = ga4Shopping.cartCache;
                //update cartCache since qty has changed
                ga4Shopping.cartCache = ga4Shopping.buildCartCache(cartLinesModel);
                _.each(cartCache, function (line) {
                    if (line.internalid == oldLineId) {
                        var cacheQty = line.itemData.item[0].quantity
                            , updatedLine = cartDetailModel ? cartDetailModel.getLatestAddition() : {}
                            , updatedLineQty = updatedLine.get('quantity');
                        if (cacheQty > updatedLineQty) {
                            ga4Shopping.trackRemoveItemInCart(updatedLine);
                        }
                        else {
                            ga4Shopping.trackAddToCartGA4(null, null, true);
                        }
                    }
                });
            }
            , trackViewCart: function (container) {
                var cartDetailedView = container.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView.model
                    , cartData = ga4Shopping.getCartItems(cartDetailModel, "trackViewCart", [], null, false);
                TTGA4Utils.trackCartViewGA4(cartData, container);
            }
            , trackRemoveItemInCartEventHandler: function (container) {
                var cartDetailedView = this.app.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView.model
                    , cartDetailLines = cartDetailModel.get('lines')
                    , cartLinesModel = cartDetailLines.models
                    , cartItemsArr = []
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                //build array with items currently in cart
                //this will be used later to get the details of the item that was removed
                //START
                ga4Shopping.cartCache = ga4Shopping.buildCartCache(cartLinesModel);
                //END
                cartDetailModel.cancelableOff('after:LiveOrder.removeLine', this.trackRemoveItemInCart, this);
                cartDetailModel.cancelableOn('after:LiveOrder.removeLine', this.trackRemoveItemInCart, this);
            }
            , trackRemoveItemInCart: function (removedLine) {
                var cartItemsArr = ga4Shopping.cartCache || [];
                var removedItem = _.reject(cartItemsArr, function (item) {
                    var removedLineId = removedLine.internalid ? removedLine.internalid : removedLine.get('internalid');
                    return removedLineId != item.internalid;
                });
                if (removedItem) {
                    TTGA4Utils.trackRemoveItemCartGA4(removedItem[0]['itemData'], ga4Shopping.app);
                }
            }
            , trackSearch: function (container) {
                var searchQuery = container.getLayout().getCurrentView().translator.getOptionValue('keywords');
                if (searchQuery) {
                    TTGA4Utils.trackSearchGA4(searchQuery, 'Search Results Page', container);
                }
            }
            , trackAddToWishlist: function (model) {
                var productListView = ga4Shopping.app.getLayout().getCurrentView().getChildViewInstance('AddToProductList').getChildViewInstance('ProductListControl')
                    , productListViewOptions = productListView.options
                    , productListViewProduct = productListViewOptions.product
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                    , itemVariant = ga4Shopping.getItemOptions(productListViewProduct, false);
                var itemName = "";
                //Use parent item name for matrix items
                if (productListViewProduct.get('item').get('matrix_parent')) {
                    itemName = productListViewProduct.get('item').get('matrix_parent')[storedisplayname2];
                } else {
                    itemName = productListViewProduct.get('item').get('storedisplayname2') || productListViewProduct.get('item').get('displayname') || productListViewProduct.get('item').get('_name');
                }
                var itemData = {
                    currency: currencyCode
                    , value: productListViewProduct.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                    , item: [{
                        item_id: productListViewProduct.get('item').get('itemid') + ""
                        , item_name: itemName
                        , currency: currencyCode
                        , price: productListViewProduct.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                    }]
                }
                if (itemVariant.length > 0) {
                    itemData['item'][0]['item_variant'] = itemVariant.join(',');
                }
                TTGA4Utils.trackAddToWishlistGA4(itemData, ga4Shopping.app);
            }
            , trackCheckout: function (container, cartview, lines, promotions, summary) {
                setTimeout(function () {
                    //console.log('ENTRE trackCheckout');
                    var cartInstance = cartview == 'minicart' ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart') : container.getLayout().getCurrentView();
                    var checkoutBtn = cartInstance.$el.find('[data-touchpoint="checkout"]');
                    var cartModel = cartInstance.model;
                    var promocodes = cartview == 'minicart' ? promotions : ga4Shopping.getPromotions(cartModel);
                    var eventData = cartview == 'minicart' ? ga4Shopping.getCartItems(lines, 'trackCheckout', promocodes, summary, true) : ga4Shopping.getCartItems(cartModel, 'trackCheckout', promocodes, summary, false);
                    if (promocodes.length > 0) {
                        eventData['coupon'] = promocodes.join(',');
                    }
                    if (cartview == 'minicart' && cartInstance.events) {
                        //debugger
                        if (checkoutBtn.length > 0) {
                            jQuery(checkoutBtn).off('click');
                            jQuery(checkoutBtn).on('click', function () {
                                TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                                //console.log("dataLayer begin checkout", JSON.stringify(window.dataLayer))
                            })
                        } else {
                            // debugger
                            var eventsObj = _.extend({}, cartInstance.events, {
                                'click [data-touchpoint="checkout"]': 'trackTTCheckout'
                            });
                            Object.defineProperty(cartInstance, 'events', {
                                get: function () {
                                    return eventsObj;
                                }
                                , set: function () {
                                    return eventsObj;
                                }
                                , configurable: true
                            })
                            cartInstance.trackTTCheckout = _.wrap(cartInstance['trackEvent'], function (fn) {
                                fn.apply(this, arguments) + TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                                //("dataLayer", JSON.stringify(window.dataLayer));
                            })
                        }
                    } else {
                        // debugger
                        if (checkoutBtn.length > 0) {
                            // _.each(checkoutBtn, function(btn)
                            // {
                            jQuery(checkoutBtn).on('click', function () {
                                TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                                //console.log("dataLayer begin checkout", JSON.stringify(window.dataLayer))
                            })
                            // })
                        }
                    }
                    //console.log("checkoutBtn", checkoutBtn);
                }, 2000);
            }
            , trackProductListsEventHandler: function (container, source) {
                var listId = ''
                    , listName = ''
                    , curView = container.getLayout().getCurrentView()
                    , listItems = []
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                if (source == 'plp') {
                    var itemModels = curView.model ? curView.model.get("items").models : [];
                    listItems = this.getListItems(itemModels)
                    listId = 'category';
                    listName = curView.model.get('category') ? curView.model.get('category').get('name') : 'All Products Page';
                    var eventData = {
                        item_list_id: listId
                        , item_list_name: listName
                        , currency: currencyCode
                        , items: listItems
                    };
                    TTGA4Utils.trackProductListGA4(eventData, container)
                }
                else {
                    this.trackOtherItemLists(container, source);
                }
            }
            , trackOtherItemLists: function (container, source) {
                var listId = ''
                    , listName = ''
                    , curView = container.getLayout().getCurrentView()
                    , listItems = []
                    , eventData = {}
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                setTimeout(function () {
                    if (source == 'correlated') {
                        var correlatedModel = curView.getChildViewInstance('Correlated.Items').collection.models;
                        if (correlatedModel.length > 0) {
                            listItems = self.getListItems(correlatedModel)
                            listId = 'correlated_items';
                            listName = 'Correlated Items';
                            eventData = {
                                item_list_id: listId
                                , item_list_name: listName
                                , currency: currencyCode
                                , items: listItems
                            };
                        }
                    }
                    if (source == 'recentlyviewed') {
                        var recentlyModel = curView.getChildViewInstance('RecentlyViewed.Items').collection.models;
                        listItems = self.getListItems(recentlyModel)
                        listId = 'recently_viewed_items';
                        listName = 'Recently Viewed Items';
                        eventData = {
                            item_list_id: listId
                            , item_list_name: listName
                            , currency: currencyCode
                            , items: listItems
                        };
                    }
                    if (source == 'related') {
                        var relatedModel = curView.getChildViewInstance('Related.Items') ? curView.getChildViewInstance('Related.Items').collection.models : [];
                        listItems = self.getListItems(relatedModel)
                        listId = 'related_items';
                        listName = 'Related Items';
                        eventData = {
                            item_list_id: listId
                            , item_list_name: listName
                            , currency: currencyCode
                            , items: listItems
                        };
                    }
                    if (listId != '' && listName != '' && listItems.length > 0) {
                        TTGA4Utils.trackProductListGA4(eventData, container)
                    }
                }, 2000);
            }
            , getListItems: function (collection) {
                var itemsArr = []
                    , items = collection.models ? collection.models : collection
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                _.each(items, function (item) {
                    var price = "";
                    if (item.get('onlinecustomerprice_detail') && item.get('onlinecustomerprice_detail').onlinecustomerprice) {
                        price = item.get('onlinecustomerprice_detail').onlinecustomerprice;
                    } else if (item.get('onlinecustomerprice')) {
                        price = item.get('onlinecustomerprice');
                    }
                    itemsArr.push({
                        item_id: item.get('itemid') + ""
                        , item_name: item.get('storedisplayname2') || item.get('displayname') || item.get('_name')
                        , price: price
                        , currency: currencyCode
                    })
                });
                return itemsArr;
            }
            , getPromotions: function (model) {
                var promocodes = model.get('promocodes') || []
                    , codes = [];
                _.each(promocodes, function (val) {
                    codes.push(val.code);
                });
                return codes;
            }
            , getCartItems: function (model, stage, promotions, summary, minicart) {
                var cartItemsObj = {};
                var itemsArr = [];
                var promocodes = [];
                var lines = [];
                var self = this;
                var currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                if (stage == 'trackCheckout' && minicart) {
                    promocodes = promotions;
                } else {
                    promocodes = ga4Shopping.getPromotions(model);
                }
                if (minicart) {
                    lines = model;
                    _.each(lines, function (item) {
                        var itemName = "";
                        //Use parent item name for matrix items
                        if (item.item.extras.matrix_parent) {
                            itemName = item.item.extras.matrix_parent.storedisplayname2;
                        } else {
                            itemName = item.item.extras.storedisplayname2 || item.item.extras.displayname || item.item.extras._name;
                        }
                        var itemVariant = self.getItemOptions(item, true)
                            , itemsObj = {
                                item_id: item.item.itemid + ""
                                , item_name: itemName
                                , quantity: item.quantity
                                , currency: currencyCode
                                , price: item.item.extras.onlinecustomerprice_detail.onlinecustomerprice
                            };
                        if (promocodes.length > 0) {
                            itemsObj['coupon'] = promocodes.join(',');
                        }
                        if (itemVariant.length > 0) {
                            itemsObj['item_variant'] = itemVariant.join(',')
                        }
                        itemsArr.push(itemsObj);
                    });
                } else {
                    lines = model.get('lines');
                    _.each(lines.models, function (line) {
                        var itemName = "";
                        //Use parent item name for matrix items
                        if (line.get('item').get('matrix_parent')) {
                            itemName = line.get('item').get('matrix_parent').storedisplayname2 || line.get('item').get('matrix_parent').get('storedisplayname2');
                        } else {
                            itemName = line.get('item').get('storedisplayname2') || line.get('item').get('displayname') || line.get('item').get('_name');
                        }
                        var itemVariant = self.getItemOptions(line, false)
                            , itemsObj = {
                                item_id: line.get('item').get('itemid') + ""
                                , item_name: itemName
                                , quantity: line.get('quantity')
                                , currency: currencyCode
                                , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                            };
                        if (promocodes.length > 0) {
                            itemsObj['coupon'] = promocodes.join(',');
                        }
                        if (itemVariant.length > 0) {
                            itemsObj['item_variant'] = itemVariant.join(',')
                        }
                        itemsArr.push(itemsObj);
                    });
                }
                cartItemsObj.currency = currencyCode;
                if (summary) {
                    cartItemsObj.value = summary.total;
                } else if (model.get('summary')) {
                    cartItemsObj.value = model.get('summary').total;
                }
                if (stage == 'trackCheckout') {
                    cartItemsObj.items_checkout = itemsArr;
                } else {
                    cartItemsObj.items = itemsArr;
                }
                return cartItemsObj;
            }
            , buildCartCache: function (line_model) {
                var cartItemsArr = []
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                _.each(line_model, function (line) {
                    var item = line.get('item')
                        , variantArr = ga4Shopping.getItemOptions(line, false)
                        , itemsObj = {
                            item_id: item.get('itemid') || item.get('internalid')
                            , item_name: item.get('storedisplayname2') || item.get('displayname')
                            , quantity: line.get('quantity')
                            , currency: currencyCode
                            , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                        };
                    if (variantArr.length > 0) {
                        itemsObj['item_variant'] = variantArr.join(',');
                    }
                    cartItemsArr.push({
                        internalid: line.get('internalid')
                        , itemData: {
                            currency: currencyCode
                            , value: line.get('amount')
                            , item: [itemsObj]
                        }
                    });
                });
                return cartItemsArr;
            }
            , getItemOptions: function (item, minicart) {
                var variantsArr = [];
                var itemOptionsModel = [];
                if (minicart) {
                    itemOptionsModel = item.options || [];
                } else {
                    var itemOptions = item.get('options') || [];
                    itemOptionsModel = itemOptions.models || [];
                }
                _.each(itemOptionsModel, function (option) {
                    var optionsValue;
                    if (minicart) {
                        optionsValue = option.value || {};
                    } else {
                        optionsValue = option.get('value') || {};
                    }
                    if (Object.keys(optionsValue).length > 0) {
                        variantsArr.push(optionsValue.label);
                    }
                });
                return variantsArr;
            }
        }
        return ga4Shopping;
    });
